export default __webpack_public_path__ + "static/media/Our_team_banner.003c47d2.mp4";